import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";
import { Layout } from "@/components/navigation/Layout";
import { isPublicRoute } from "@/config/routes";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  const isPublic = isPublicRoute(location.pathname);

  if (isPublic) {
    // 認証不要ルートは直接Outletをレンダリング（Layoutなし）
    return <Outlet />;
  }

  // 認証が必要なルートはLayoutを使用
  return <Layout />;
}
